<h3 class="eb-review-title d-none d-lg-block">
  {{ 'checkoutReview.review' | cxTranslate }}
</h3>

<div class="eb-review-summary row">
  <ng-container *ngIf="(steps$ | async)?.slice(0, -1) as steps">
    <div class="col-md-6 col-lg-3 col-xl-3">
      <ng-container *ngFor="let step of paymentSteps(steps)">
        <ng-container *ngIf="step.type[0] === 'paymentDetails'">
          <ng-container *ngTemplateOutlet="poNumber"></ng-container>
          <ng-container *ngTemplateOutlet="paymentType"></ng-container>
        </ng-container>
      </ng-container>
    </div>
    <div class="col-md-6 col-lg-3 col-xl-3">
      <ng-container *ngFor="let step of deliverySteps(steps)">
        <ng-container *ngIf="step.type[0] === 'deliveryAddress'">
          <ng-container *ngTemplateOutlet="shippingAddress"></ng-container>
        </ng-container>
      </ng-container>
    </div>
    <div class="col-md-6 col-lg-3 col-xl-3">
      <ng-container *ngTemplateOutlet="invoiceAddress"></ng-container>
    </div>
    <div class="col-md-6 col-lg-3 col-xl-3">
      <ng-container *ngTemplateOutlet="deliveryMode"></ng-container>
    </div>
  </ng-container>
</div>

<!-- PO NUMBER SECTION -->
<ng-template #poNumber>
  <div class="eb-review-summary-card">
    <eb-card
      [ghost]="true"
      [content]="getPoNumberCard(poNumber$ | async) | async"
      class="eb-review-card"
    ></eb-card>
    <div class="eb-review-submit__edit-step">
      <a
        [routerLink]="
          {
            cxRoute: getCheckoutStepUrl(checkoutStepType_PAYMENT_TYPE)
          } | cxUrl
        "
        ><cx-icon [type]="IconType.PEN"></cx-icon
      ></a>
    </div>
  </div>
</ng-template>

<!-- PAYMENT TYPE SECTION -->
<ng-template #paymentType>
  <div class="eb-review-summary-card">
    <eb-card
      *ngIf="paymentType$ | async as paymentType"
      [ghost]="true"
      [content]="getPaymentTypeCard() | async"
      class="eb-review-card"
    ></eb-card>
  </div>
</ng-template>

<!-- INVOICE ADDRESS SECTION -->
<ng-template #invoiceAddress>
  <div *ngIf="cart$ | async as cart" class="eb-review-summary-card">
    <eb-card
      [ghost]="true"
      [content]="getInvoiceAddressCard(cart.paymentAddress) | async"
      class="eb-review-card"
    ></eb-card>
  </div>
</ng-template>

<!-- SHIPPING ADDRESS SECTION -->
<ng-template #shippingAddress>
  <div *ngIf="deliveryAddress$ | async as deliveryAddress" class="eb-review-summary-card">
    <eb-card
      [ghost]="true"
      [content]="getShippingAddressCard(deliveryAddress) | async"
      class="eb-review-card"
    ></eb-card>
    <div class="eb-review-submit__edit-step">
      <a [routerLink]="{ cxRoute: getCheckoutStepUrl(checkoutStepType_DELIVERY_ADDRESS) } | cxUrl">
        <cx-icon [type]="IconType.PEN"></cx-icon>
      </a>
    </div>
  </div>
</ng-template>

<!-- DELIVERY MODE SECTION -->
<ng-template #deliveryMode>
  <div *ngIf="cart$ | async as cart" class="eb-review-summary-card">
    <div *ngIf="isValidatingShippingDate$ | async; else loaded">
      <eb-card
        *ngIf="deliveryMode$ | async as deliveryMode"
        [ghost]="true"
        [content]="
          getDeliveryCard(deliveryMode, getShippingDate() | cxDate: 'mediumDate' : 'UTC', cart?.completeDelivery, true)
            | async
        "
        class="eb-review-card"
      ></eb-card>
    </div>
    <ng-template #loaded>
      <eb-card
        *ngIf="deliveryMode$ | async as deliveryMode"
        [ghost]="true"
        [content]="
          getDeliveryCard(deliveryMode, getShippingDate() | cxDate: 'mediumDate' : 'UTC', cart?.completeDelivery, false)
            | async
        "
        class="eb-review-card"
      ></eb-card>
    </ng-template>
    <div class="eb-review-submit__edit-step">
      <a [routerLink]="{ cxRoute: getCheckoutStepUrl(checkoutStepType_DELIVERY_MODE) } | cxUrl">
        <cx-icon [type]="IconType.PEN"></cx-icon>
      </a>
    </div>
  </div>
</ng-template>

<!-- PAYMENT METHOD SECTION -->
<ng-template #paymentMethod>
  <div class="eb-review-summary-card">
    <div>
      <eb-card
        *ngIf="paymentDetails$ | async as paymentDetails"
        [ghost]="true"
        [content]="getPaymentMethodCard(paymentDetails) | async"
        class="eb-review-card"
      ></eb-card>
    </div>
    <div class="eb-review-submit__edit-step">
      <a [routerLink]="{ cxRoute: getCheckoutStepUrl(checkoutStepType_PAYMENT_DETAILS) } | cxUrl">
        <cx-icon [type]="IconType.PEN"></cx-icon>
      </a>
    </div>
  </div>
</ng-template>

<!-- CART ITEM SECTION -->
<ng-container *ngIf="cart$ | async as cart">
  <h3 class="eb-review-title d-none d-lg-block d-xl-block">
    {{ 'cartDetails.cartName' | cxTranslate }}
  </h3>
  <div class="cx-review-cart-item col-md-12 row" *ngIf="entries$ | async as entries">
    <eb-cart-item-list
      [items]="entries"
      [readonly]="true"
      class="eb-review-submit__cart-item-list"
    ></eb-cart-item-list>
  </div>
</ng-container>
